export default ({ h, s, l }) => {
  let v = l + s * Math.min(l, 1 - l),
    sv = v === 0 ? 0 : 2 * (1 - l / v);
  return { h, s: sv, v };
};
